import * as React from "react";
import {Post} from "../../types/Post";
import {MDXRenderer} from "gatsby-plugin-mdx";

interface DisplayPageProps {
	post: Post;
}

const DisplayPage: React.FC<DisplayPageProps> = (props) => {
	const {post} = props;
	return (
		<div className="w-full bg-white">
			<div className="max-w-4xl mx-auto px-6 py-10">
				<div className="r py-6">
					<p className=" text-sm text-metalic">
						<MDXRenderer>
							{post.body}
						</MDXRenderer>
					</p>
				</div>
			</div>
		</div>
	);
};

export default DisplayPage;
